import type { ReactNode, ErrorInfo } from 'react';
import { Component } from 'react';

import { translate } from '@vimeo/i18n-runtime';
import { Box } from '@vimeo/primitives';
import type { Viewer } from '@vimeo/viewer';

import { sendPlayerError } from '../utils/postMessage';
import { ResponsiveBox } from './ResponsiveComponents';

interface IErrorBoundaryProps {
  children: ReactNode | undefined;
  viewer: Viewer | null;
}

interface IErrorBoundaryState {
  error: Error | null;
}

export class ErrorBoundary extends Component<IErrorBoundaryProps, IErrorBoundaryState> {
  public override state: IErrorBoundaryState = {
    error: null,
  };

  public override componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    this.setState({ error });

    sendPlayerError(error);
  }

  public override render(): ReactNode {
    const { viewer } = this.props;
    const { error } = this.state;

    if (error) {
      return (
        <ResponsiveBox
          alignItems="center"
          alignSelf="center"
          gap="1rem"
          display="flex"
          flexDirection="column"
          p="16px"
        >
          <Box>{translate('Oops! Something went wrong. Please try again.')}</Box>

          {viewer?.user?.badge?.type === 'staff' ? (
            <>
              <Box>{error?.name}</Box>
              <Box>{error?.message}</Box>
            </>
          ) : null}
        </ResponsiveBox>
      );
    }

    return this.props.children;
  }
}
